import accessEventHelpers from './accessEvent';
import accountHelpers from './account';
import affiliationHelpers from './affiliation';
import bookmarkHelpers from './bookmark';
import calendarHelpers from './calendar';
import collectionHelpers from './collection';
import layoutHelpers from './layout';
import modalHelpers from './modal';
import propertyHelpers from './property';
import ratingHelpers from './rating';
import resourceHelpers from './resource';
import searchHelpers from './search';
import tagHelpers from './tag';
import teamHelpers from './team';
import themeHelpers from './theme';
import uploadedDocumentHelpers from './uploadedDocument';
import organizationHelpers from './organization';
import reportHelpers from './report';
import { DateHelper } from './date';
import csvHelper from './csv';

export const compiling_uri = (uri) => {
  return `${process.env.REACT_APP_ROOT_COMPILING_PATH}/${uri}`;
};

export const angular_host_uri = (uri) => {
  return `${process.env.REACT_APP_ODAS_HOST}/${uri}`;
};

export const isPresent = (variable) => {
  return variable != undefined && variable !== '' && variable != null;
};

export const pathsInReact = [
  // using the same regex from nginx, but this is set as an array in case it make sense to list each path separately in the future
  // NOTE: changes made here should be reflected in the dev-env-dockerized repo /nginx-staging/auth.conf (when ready for staging)
  // and also made in this repo /nginx.conf (when ready to deploy to production)
  /^\/(stayhousedbayarea|familyresourcefinder(\/results\/)?|test-host|home|dashboard|browse|settings|signup|login|confirm-login|onboarding-saml|referrals\/new|(org\/[^\/]+\/reports\/(assessments-summary|referral-summary)|(org\/[^\/]+\/intake))|plan|assessments\/(?!(diabetes-risk|depression|food-insecurity|housing-insecurity|housing-helper|prapare|prapare-sfhp-network|hiv-risk-assessment)$)[^\/]+|collections(\/.*)?|collection\/[^\/]+|lists\/[^\/]+|(clients(\/$)?(\/\d+(\/)?)?(?!.+))|(clients\/\d+\/referrals\/\d+\/attachments\/\d+)|(clients\/\d+\/assessments\/\d+)|opp\/[^\/.]+$)/
];

// update this array as more assessments are handled in react instead of angular (see regex above)
export const isReactAssessment = (slug) => {
  return ['pearls'].includes(slug);
};

export {
  accessEventHelpers,
  accountHelpers,
  affiliationHelpers,
  bookmarkHelpers,
  calendarHelpers,
  collectionHelpers,
  layoutHelpers,
  modalHelpers,
  propertyHelpers,
  ratingHelpers,
  resourceHelpers,
  searchHelpers,
  tagHelpers,
  teamHelpers,
  themeHelpers,
  uploadedDocumentHelpers,
  DateHelper,
  organizationHelpers,
  reportHelpers,
  csvHelper
};
